import { gql } from '@apollo/client';

export const GET_GENERIC_EVALUATION_ENTITIES = gql`
  query genericEvaluationEntities {
    genericEvaluationEntities {
      code
      documentKey
      documentTypeId
      genericEvaluationEntityId
      name
    }
  }
`;
